export const showSwal = async (icon, title, text) => {
    const Swal = (await import("sweetalert2")).default;
    Swal.fire({
        icon,
        title,
        text,
        confirmButtonText: "Close",
        allowOutsideClick: false,
    });
};

export const showAlert = async (icon, title, text, options = {}) => {
    const Swal = (await import("sweetalert2")).default;
    return Swal.fire({
        icon,
        title,
        text,
        confirmButtonText: "Close",
        allowOutsideClick: false,
        ...options,
    });
};

export const showAlertAndNavigate = async (icon, title, text, token) => {
    const Swal = (await import("sweetalert2")).default;
    Swal.fire({
        icon,
        title,
        text,
        confirmButtonText: "Continue",
        allowOutsideClick: false
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = `/?token=${token}`;
        }
    });
};

export const showWarning = (title, text = "", options = {}) =>
    showAlert("warning", title, text, options);